// extracted by mini-css-extract-plugin
export var skipAnimation = "_y-0";